import { render } from "./MsgLeftNav.vue?vue&type=template&id=9a99a232&scoped=true"
import script from "./MsgLeftNav.vue?vue&type=script&lang=js"
export * from "./MsgLeftNav.vue?vue&type=script&lang=js"

import "./MsgLeftNav.vue?vue&type=style&index=0&id=9a99a232&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a99a232"]])

export default __exports__